import { render, staticRenderFns } from "./ProjectObject.vue?vue&type=template&id=30d4c7a0&"
import script from "./ProjectObject.vue?vue&type=script&lang=js&"
export * from "./ProjectObject.vue?vue&type=script&lang=js&"
import style0 from "./ProjectObject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports